import {goldenSection, GS} from './modules/golden-section';

// const goldenSection = require('golden_section').goldenSection;
// const GS = require('golden_section').GS;

document.addEventListener('DOMContentLoaded', ()=> {

    const ui = goldenSection.generate({
        targetNodeId: "golden-section-wrapper",
        orientation: GS.ORIENTATION.RIGHT,
        alignment: GS.ALIGN.CENTER,
        verticalAlignment: GS.VERTICAL_ALIGN.MIDDLE,
        rotation: GS.ROTATION.CW,
        sectionCount: 7,
        sectionClasses: ["section-square","section-round"],
        majorAxisMax: 1100,
        majorAxisMin: 100,
        cssTransition: {
            duration: 500,
            timing: "linear"
        },
        renderInterval: 100,
        resizeThrotleInterval: 2
    });
    if (!ui){
        throw new Error('Failed to create the UI object')
    }

    const rotations = [GS.ROTATION.CW, GS.ROTATION.CCW];
    const orientations = [GS.ORIENTATION.TOP, GS.ORIENTATION.RIGHT, GS.ORIENTATION.BOTTOM, GS.ORIENTATION.LEFT];
    const alignments = [GS.ALIGN.LEFT, GS.ALIGN.CENTER, GS.ALIGN.RIGHT];
    const vertical_alignments = [GS.VERTICAL_ALIGN.TOP, GS.VERTICAL_ALIGN.MIDDLE, GS.VERTICAL_ALIGN.BOTTOM];
    const class_options = ['golden-box', 'section-square', 'section-round', 'rounded-square', 'super-rounded-square', 'black-box', 'white-box'];
    const transition_durations = [100,250,500,750,1000,1500,200];
    const transition_timings = ["linear","ease","ease-in","ease-out"];

    function getRandomClasses(){
        const count = 2;
        const selected_classes = [];
        for (let i = 0; i < count; i++) {
            selected_classes.push(class_options[Math.floor(Math.random() * 7)]);
        }
        return selected_classes;
    }

    const interval = setInterval(()=>{
        ui.transformUi({
            orientation: orientations[Math.floor(Math.random() * 4)],
            alignment: alignments[Math.floor(Math.random() * 3)],
            verticalAlignment: vertical_alignments[Math.floor(Math.random() * 3)],
            rotation: rotations[Math.floor(Math.random() * 2)],
            sectionClasses: getRandomClasses(),
            cssTransition: {
                duration: transition_durations[Math.floor(Math.random() * 7)],
                timing: transition_timings[Math.floor(Math.random() * 4)]
            },
            transformInterval: 100,
        });         
    }, 3000);


    // setTimeout(()=>{
    //     clearInterval(interval);
    // }, 10000);

        
});